import React, { useEffect, useState } from "react";

export default function PwaInstallBar() {
  const [isReadyForInstall, setIsReadyForInstall] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (event) => {
      // Prevent the mini-infobar from appearing on mobile
      event.preventDefault();
      window.deferredPrompt = event;
      setIsReadyForInstall(true);
    };

    // Listen for the beforeinstallprompt event
    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    // Check if the app is already installed (optional)
    if (window.matchMedia("(display-mode: standalone)").matches) {
      setIsInstalled(true);
    }

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, []);

  const downloadApp = async () => {
    const promptEvent = window.deferredPrompt;
    if (!promptEvent) return;

    // Show the install prompt
    promptEvent.prompt();

    // Wait for the user's choice
    const result = await promptEvent.userChoice;
    console.log("User choice:", result);

    // If the user accepted the prompt, hide the install bar
    if (result.outcome === "accepted") {
      setIsReadyForInstall(false);
      setIsInstalled(true);
    }

    // Reset the deferred prompt so it can't be triggered again
    window.deferredPrompt = null;
  };

  return (
    !isInstalled && isReadyForInstall && (
      <div className="fixed top-0 bg-white left-0 w-full text-[13px] text-[#808080] p-4 flex justify-between items-center z-50 ">
        <span>Descargar la app aquí</span>
        <button
          onClick={downloadApp}
          className="bg-[#F1511B] text-white px-4 py-2 rounded-md  transition"
        >
          Descargar
        </button>
      </div>
    )
  );
}
